import Box from '@mui/material/Box';
import React, { FC } from 'react';
import { IWindowAwareProps } from 'types/common';

const LoginContainer: FC<IWindowAwareProps> = ({ children }) => (
	<Box
		display="flex"
		flexDirection="row"
		flexGrow={1}
		id="login-container-main"
	>
		<Box
			display="flex"
			flexGrow={1}
			flexDirection="column"
			data-testid="login-container-body"
			style={{
				background:
					'conic-gradient(from 73.6deg at 50% 50%, #86C440 -102.55deg, #0884B6 0.19deg, #70CDDD 131.9deg, #86C440 257.45deg, #0884B6 360.19deg)'
			}}
		>
			{children}
		</Box>
	</Box>
);

export default LoginContainer;
